<template>
	<TemplateBlog v-bind="props">
		<template #intro>
			<slot name="intro" />
		</template>
		<slot />
	</TemplateBlog>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { StrapiBlogCategoryType } from '#base/core/types/cms/StrapiBlogCategoryType';
import type { StrapiBlogTagType } from '#base/core/types/cms/StrapiBlogTagType';
import type { StrapiWriterType } from '#base/core/types/cms/StrapiWriterType';

const props = defineProps<{
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
	title: string;
	subtitle: string;
	featuredImage?: {
		alt: string;
		src: string;
		placeholderSrc?: string;
	};
	tags?: StrapiBlogTagType[];
	category: StrapiBlogCategoryType;
	writer: StrapiWriterType;
}>();
</script>
